import { calculatorApi } from '../calculatorApi';
import { CalculateReimbursementRequest, ReimbursementResult } from '../types';

const calculatorEndpointsInjected = calculatorApi.injectEndpoints({
  endpoints: (builder) => ({
    calculateReimbursement: builder.mutation<ReimbursementResult, CalculateReimbursementRequest>({
      query: (body) => ({
        url: 'api/Reimbursement/calculate',
        method: 'POST',
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const calculatorEndpoints = calculatorEndpointsInjected;

export const { useCalculateReimbursementMutation } = calculatorEndpointsInjected;
